import { ImageBlockBlock } from 'src/types/articleCmsTypes';

import s from './Image.module.scss';

export function Image({
  src,
  alt,
  description,
}: Omit<ImageBlockBlock, 'type'>) {
  return (
    <figure className={s.root}>
      <img className={s.img} src={src} alt={alt || 'img'} />
      <figcaption className={s.desc}>{description}</figcaption>
    </figure>
  );
}
